import { Component, OnInit, OnDestroy } from "@angular/core";
import { Observable, Subject, combineLatest, distinctUntilChanged, filter, of, take, takeUntil } from "rxjs";
import { DataService } from "src/app/shared/services/data.service";
import { PositionService } from "src/app/shared/services/position.service";
import { Position } from "../../position/models/position";
import { faChartPie } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-account-positions',
    templateUrl: './account-positions.component.html',
    styleUrl: './account-positions.component.scss',
    standalone: false
})
export class AccountPositionsComponent implements OnInit, OnDestroy {

    faChartPie: any = faChartPie;

    public displayedColumns: string[] = ['symbol', 'quantity', 'avgPrice', 'longShort'];
    public totalRecords: number = 0;
    public elements$: Observable<Position[]>;

    public loading: boolean = true;
    private onDestroy$ = new Subject<void>();
    private currentRiaId: number;
    private currentAccountPk: number;

    constructor(
        private data: DataService,
        private positionService: PositionService,
    ) { }

    ngOnInit(): void {
        combineLatest([
            this.data.currentRiaId$.pipe(
                distinctUntilChanged(),
                filter(riaId => !!riaId),
                take(1) // Take only the first valid riaId
            ),
            this.positionService.accountPkChanged$.pipe(
                distinctUntilChanged(),
                filter(accountPk => !!accountPk),
            )
        ])
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(([riaId, accountPk]) => {
            this.currentRiaId = riaId;
            this.currentAccountPk = accountPk;
            this.loadPositions(riaId, accountPk);
        });

        this.positionService.positionRefresh$.pipe(
            takeUntil(this.onDestroy$),
            filter(shouldRefresh => shouldRefresh === true)
        ).subscribe(() => {
            if (this.currentRiaId && this.currentAccountPk) {
                this.loadPositions(this.currentRiaId, this.currentAccountPk);
            }
        });
    }

    private loadPositions(riaId: number, accountPk: number): void {
        this.loading = true;
        this.positionService.getDVPAccountPosition(riaId, accountPk)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((positions: Position[]) => {
                this.totalRecords = positions.length;
                this.elements$ = of(positions);
                this.loading = false;
            });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}

